import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  // Filter out undefined, null, and non-constructor values to prevent _getTag errors
  const filteredInputs = inputs.filter((input) => {
    if (input == null) return false;
    // Check if it's a valid class value (string, object, array, or function)
    const type = typeof input;
    return type === 'string' || type === 'object' || type === 'function';
  });
  return twMerge(clsx(filteredInputs))
}
